import React, { ReactNode } from 'react';
import './FormComponents.css';

interface FormGroupProps {
  children: ReactNode;
  className?: string;
}

interface FormLabelProps {
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

interface FormButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'success';
  children: ReactNode;
}

interface FormErrorProps {
  children: ReactNode;
}

// Form Group
export const FormGroup: React.FC<FormGroupProps> = ({ children, className = '' }) => {
  return (
    <div className={`form-group ${className}`}>
      {children}
    </div>
  );
};

// Form Label
export const FormLabel: React.FC<FormLabelProps> = ({ 
  htmlFor, 
  children, 
  className = '' 
}) => {
  return (
    <label htmlFor={htmlFor} className={`form-label ${className}`}>
      {children}
    </label>
  );
};

// Form Input
export const FormInput: React.FC<FormInputProps> = ({ 
  className = '', 
  ...props 
}) => {
  return (
    <input 
      className={`form-input ${className}`}
      {...props}
    />
  );
};

// Form Textarea
export const FormTextarea: React.FC<FormTextareaProps> = ({ 
  className = '', 
  ...props 
}) => {
  return (
    <textarea 
      className={`form-textarea ${className}`}
      {...props}
    />
  );
};

// Form Button
export const FormButton: React.FC<FormButtonProps> = ({ 
  variant = 'primary',
  children,
  className = '',
  ...props 
}) => {
  return (
    <button 
      className={`form-button form-button--${variant} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

// Form Error Message
export const FormError: React.FC<FormErrorProps> = ({ children }) => {
  return (
    <div className="form-error">
      {children}
    </div>
  );
};